import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  selector: 'smarsh-custom-loading-overlay',
  standalone: true,
  template: `
    <div class="ag-overlay-loading-center" role="presentation">
      <div
        role="presentation"
        style="width: 100px; height: 100px; background: url('/assets/brand/ccLogoMarkColor.png') center / contain no-repeat; margin: 0 auto;"></div>
      <div aria-live="polite" aria-atomic="true">
        {{ loadingMessage }}
      </div>
    </div>
  `
})
export class CustomLoadingOverlayComponent
  implements ILoadingOverlayAngularComp
{
  loadingMessage: string;

  agInit(params: ILoadingOverlayParams): void {
    this.loadingMessage = params['loadingMessage'];
  }
}
